import { useState, useRef, useCallback } from 'react'

// interface UseDebounceOptions {
//     ignoreInitialUpdate?: boolean
//     maxSuppressedMs?: number
// }

export default function useDebounce2<T>(delay: number, maxSuppressedMs?: number, onValueSet?: (value: T) => void) {
    const [debouncedValue, set_debouncedValue] = useState<T>()

    const timer = useRef<NodeJS.Timeout>()
    const lastSetTimeRef = useRef<Date>(new Date())

    const setValue = useCallback(
        (value: T) => {
            clearTimeout(timer.current)

            if (maxSuppressedMs) {
                const dt = new Date().getTime() - lastSetTimeRef.current.getTime()
                if (dt > maxSuppressedMs) {
                    lastSetTimeRef.current = new Date()
                    set_debouncedValue(value)
                    onValueSet && onValueSet(value)
                    return
                }
            }

            timer.current = setTimeout(() => {
                lastSetTimeRef.current = new Date()
                set_debouncedValue(value)
                onValueSet && onValueSet(value)
            }, delay)

            return () => {
                clearTimeout(timer.current)
            }
        },
        [delay, maxSuppressedMs]
    )

    return {
        value: debouncedValue,
        setValue,
    }
}

// const firstUpdate = useRef(options?.ignoreInitialUpdate || false)
// useEffect(() => {
//     if (firstUpdate.current) {
//         firstUpdate.current = false
//         return
//     }

//     // Set debouncedValue to value (passed in) after the specified delay
//     const handler = setTimeout(() => {
//         lastSetTimeRef.current = new Date()
//         set_debouncedValue(value)
//     }, delay)

//     return () => {
//         if (options?.maxSuppressedMs) {
//             if (+new Date() - +lastSetTimeRef.current > options?.maxSuppressedMs) {
//                 lastSetTimeRef.current = new Date()
//                 set_debouncedValue(value)
//             }
//         }

//         clearTimeout(handler)
//     }
// }, [delay, value])
